import React, { useState } from 'react';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';
import { useRegistrationFormInstance } from '../useSelfRegistrationFormInstance';
import AwsWafCaptchaWidget, { AwsWafScript } from '@components/AwsCaptchaWidget';
import { Checkbox } from 'ALIASED-antd';
import { infoModal } from 'vl-common/src/components/Modals';
import { useTranslation } from 'react-i18next';

export const CaptchaFormItem = (props: RegistrationFormItemProps) => {
  const { t } = useTranslation('common');
  const form = useRegistrationFormInstance();
  const [isCaptchaPassed, setIsCaptchaPassed] = useState(false);

  const onPuzzleSolved = (token: string) => {
    form.setFieldValue('captcha', token);
    setIsCaptchaPassed(true);
  };

  const renderCaptchaModal = () => {
    const captchaModal = infoModal({
      content: (
        <AwsWafCaptchaWidget
          onSuccess={(token) => {
            onPuzzleSolved(token);
            captchaModal.destroy();
          }}
        />
      ),
      closable: true,
      okButtonProps: { style: { display: 'none' } },
      cancelButtonProps: { style: { display: 'none' } }
    });
  };

  return (
    <>
      <AwsWafScript />
      <RegistrationFormItem
        name="captcha"
        required
        validateTrigger="onSubmit"
        rules={[
          {
            validator: (_, __, callback) => {
              if (isCaptchaPassed) {
                return callback();
              }
              return callback(t('Please click to prove you are not a robot'));
            }
          }
        ]}
        {...props}
      >
        <Checkbox
          checked={isCaptchaPassed}
          disabled={isCaptchaPassed}
          onChange={renderCaptchaModal}
          data-testid="captcha-checkbox"
        >
          {t("I'm not a robot")}
        </Checkbox>
      </RegistrationFormItem>
    </>
  );
};
